import MultiSelect from '@/components/common/MultiSelect';
import { CountyProps } from '@/models/County';

export function CountySelect({
  selectedCounties,
  onCountiesChange,
  countiesInState,
}: {
  selectedCounties: string[];
  onCountiesChange: (countyIds: string[]) => void;
  countiesInState: CountyProps[];
}) {
  return (
    <MultiSelect
      id='select-county'
      options={countiesInState?.map((c: CountyProps) => ({
        key: c.name,
        name: c.name,
        value: c.id.toString(),
      }))}
      label='Counties'
      selectedValues={selectedCounties}
      setSelectedValues={onCountiesChange}
      required
    />
  );
}
